angular.module('app.filters').filter('timespan', function($filter){

  const dateFilter = $filter('date');
  const ndash = ` ${String.fromCharCode(8211)} `;

  return function(input) {
    const startsAt = new Date(input[0]);
    const stopsAt = new Date(input[1]);

    const from = dateFilter(startsAt, 'hh:mm a');
    if (stopsAt.getFullYear() >= 9000) {
      return from + ' (open-ended)';
    } else {
      return from + ndash + dateFilter(stopsAt, 'hh:mm a');
    }
  };
});



// WEBPACK FOOTER //
// ./filters/timespan.js